models.service('DocumentModel', [
    '$q', 'API', 'ErrorService', 'Utils', 'constants',
    function ($q, API, ErrorService, Utils, Const) {
        function Document(data) {
            var self = this;

            self.id = data.id;
            self.type = data.type;
            self.status = data.status;
            self.url = data.url;
            self.category = data.category;
            self.baseCategory = data.baseCategory;
            self.uploadStatus = 0;
            self.isUploading = false;


            function checkResponse(data) {
                if (data.status !== 1) {
                    throw new ErrorService({
                        source: 'DocumentModel',
                        type: Const.error.type.VALIDATION,
                        code: data.code,
                        severity: 'warning',
                        data: {response: data}
                    });
                }
                return data;
            }

            this.startUpload = function (file) {
                self.isUploading = true;

                var uploadRequest = {
                    name: file.name,
                    size: file.size,
                    type: Const.documentFromTypes[self.type]
                };

                return API.document(uploadRequest)
                    .then(checkResponse)
                    .then(function (response) {
                        return response.fileMD5
                    })
                    .catch(function (error) {
                        self.isUploading = false;
                        return $q.reject(error);
                    });
            };

            this.loadChunk = function (fileName, offset, chunk) {
                var reader = new FileReader();
                reader.readAsBinaryString(chunk);

                return $q(function (resolve) {
                    reader.onload = function (_chunk) {
                        reader = null;
                        resolve({
                            fileMD5: fileName,
                            data: _chunk.target.result
                        });
                    };
                })
            };

            this.sendChunk = function (request) {
                return API.documentUpload(request)
                    .then(checkResponse)
                    .then(function (response) {
                        self.uploadStatus = response.percent
                    });
            };

            this.uploadFile = function (file, newFileName) {
                var chunkSize = 51206;
                var chunks = Math.ceil(file.size / chunkSize);
                var chunksData = [];

                function createChunk(offset) {
                    return function () {
                        return self.loadChunk(newFileName, offset, file.slice(offset, offset + chunkSize))
                            .then(self.sendChunk)
                    }
                }

                for (var chunk = 0; chunk <= chunks - 1; chunk++) {
                    chunksData.push(createChunk(chunk * chunkSize));
                }

                return chunksData.reduce(function (promise, fn) {
                    return promise.then(fn)
                }, $q.resolve())
                    .then(function () {
                        self.isUploading = false
                    })
                    .catch(function (error) {
                        self.isUploading = false;
                        return $q.reject(error);
                    });
            };
        }

        return Document;
    }]);